import { apiSend, getRoute } from "@services/axios";
import { store } from "@services/redux/store";

// ====================================
// MAIN FUNCTION
// ====================================

export const postEvent = async (productId = null, productData, level) => {
  switch (level) {
    case 1:
      return await postEventStep1(productData);
    case 2:
      return await postEventStep2(productId, productData);
    case 3:
      return await postEventStep3(productId, productData);
    default:
      throw new Error(`Unsupported level: ${level} for event product`);
  }
};

export default postEvent;

// ====================================
// STEP 1 - CREATE EVENT PRODUCT
// ====================================

export const postEventStep1 = async (productData) => {
  try {
    console.log("EVENT STEP 1 PRODUCT DATA:", productData);
    const url = `${getRoute("CREATE_EVENT_STEP_1")}`;
    const response = await apiSend(url, "post", productData);
    handleBackendErrors(response.data);
    localStorage.setItem("product_id_save", response?.data?.result?.product_id);
    console.log("EVENT STEP 1 RESPONSE:", response);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
};

// ====================================
// STEP 2 - UPDATE EVENT DETAILS
// ====================================

export const postEventStep2 = async (product_id, productData) => {
  try {
    const productType = "Event";
    const stateData =
      store.getState()[productType.toLowerCase()]?.step2 || productData;
    console.log("EVENT STEP 2 PRODUCT DATA:", stateData);
    const url = `${getRoute("CREATE_EVENT_STEP_2")}/${product_id}`;
    const response = await apiSend(url, "post", stateData);
    handleBackendErrors(response.data);
    console.log("EVENT STEP 2 RESPONSE:", response);
    return response.data;
  } catch (error) {
    throw formatBackendError(error);
  }
};

// ====================================
// STEP 3 - FINAL PRICING + POLICIES
// ====================================

export const postEventStep3 = async (product_id, productData) => {
  try {
    const productType = "Event";
    const stateData =
      store.getState()[productType.toLowerCase()]?.step3 || productData;
    console.log("EVENT STEP 3 PRODUCT DATA:", stateData);
    const url = `${getRoute("CREATE_EVENT_STEP_3")}/${product_id}`;
    const response = await apiSend(url, "post", stateData);

    handleBackendErrors(response.data);
    return response?.data;
  } catch (error) {
    throw formatBackendError(error);
  }
};

// ====================================
// HELPER FUNCTIONS
// ====================================

function handleBackendErrors(data) {
  if (!data) return;

  const backendMsg = data?.request?.message;
  const backendError = data?.result?.Error;

  if (backendMsg && backendMsg.toLowerCase().includes("invalid request data")) {
    if (backendError && typeof backendError === "object") {
      console.table(flattenBackendErrors(backendError));
    }
    throw new Error(backendMsg);
  }

  if (backendError && typeof backendError === "object") {
    const firstKey = Object.keys(backendError)[0];
    const firstMsg = backendError[firstKey]?.[0] || "Unknown backend error";
    throw new Error(firstMsg);
  }
}

function formatBackendError(error) {
  if (error?.response?.data) {
    handleBackendErrors(error.response.data);
  }
  return new Error(
    error.message || "An unknown error occurred during event submission."
  );
}

function flattenBackendErrors(errorObj) {
  const rows = [];
  for (const key in errorObj) {
    const value = errorObj[key];
    if (Array.isArray(value)) {
      value.forEach((msg) => rows.push({ field: key, message: msg }));
    } else if (typeof value === "object") {
      for (const subKey in value) {
        rows.push({ field: `${key}.${subKey}`, message: value[subKey] });
      }
    } else {
      rows.push({ field: key, message: value });
    }
  }
  return rows;
}
